import ActiveSessionsPage from "./ActiveSessionsPage";

export default ActiveSessionsPage;